function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7368 12.8421C14.4752 12.2591 12.6004 11.5789 12.6004 10.8988V6.04047C12.6004 2.83399 10.246 0.21051 7.36842 0.21051C4.49081 0.21051 2.13641 2.83399 2.13641 6.04047V10.8988C2.13641 11.5789 0.261601 12.2591 0 12.8421H14.7368Z",
  fill: "#FAFAFA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.31826 14.9615C8.86272 15.6538 8.10348 16 7.34423 16C6.96461 16 6.58499 15.9307 6.20537 15.7231C5.82575 15.5154 5.59797 15.3077 5.3702 14.9615C5.14243 14.6154 5.29428 14.2 5.6739 13.9923C6.05352 13.7846 6.50907 13.9231 6.73684 14.2692C6.81276 14.3384 6.88869 14.4769 7.04054 14.5461C7.42016 14.7538 7.8757 14.6154 8.10348 14.2692C8.33125 13.9231 8.78679 13.8538 9.16642 13.9923C9.54604 14.1308 9.54604 14.6154 9.31826 14.9615Z",
  fill: "#FAFAFA"
});

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.84f8e211.svg";
export { ForwardRef as ReactComponent };